<template>
  <v-autocomplete
    dense
    color="cyan"
    filled
    :id="id"
    :items="timeList"
    v-model="time"
    :rules="rules"
    :placeholder="placeholder"
    solo
    flat
    :disabled="disabled"
    :readonly="readonly"
    item-color="cyan"
    hide-details
    :menu-props="{ auto: true }"
    v-on:change="emitValue()"
  />
</template>

<script>
import moment from "moment-timezone";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "timepicker",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    id: {
      type: String,
      default: "start-time",
    },
    placeholder: {
      type: String,
      default: "Start Time",
    },
    value: {
      type: String,
      default: null,
    },
    minTime: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    minDate: {
      type: String,
      default: moment().format("YYYY-MM-DD"),
    },
    minDateReference: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    value: function () {
      this.init();
    },
    minTime: function () {
      this.initTimeList();
    },
    minDate: function () {
      this.init();
      this.initTimeList();
    },
  },
  data() {
    return {
      time: null,
      timeList: [],
    };
  },
  methods: {
    init() {
      this.time = this.value;
      if (this.type == "start-time" || this.type == "end-time") {
        if (Array.isArray(this.timeList)) {
          const exists = this.timeList.some((item) => item.value === this.time);
          if (!exists) {
            this.time = this.type == "start-time" ? "12:00 AM" : "11:45 PM";
            this.emitValue();
          }
        }
      }
    },
    emitValue() {
      this.$emit("input", this.time);
      this.$emit("change", this.time);
    },
    initTimeList() {
      this.timeList = [];
      let startTime = moment(this.minDate).startOf("day");
      let endTime = moment(this.minDate).endOf("day");
      const referenceDate = this.minDateReference || this.minDate;
      const applyTimeConstraint =
        moment(this.minDate).isSame(moment(referenceDate), "day");
      let minTime = applyTimeConstraint && this.minTime
        ? moment(`${referenceDate} ${this.minTime}`, "YYYY-MM-DD hh:mm A")
        : null;
      while (startTime.isBefore(endTime)) {
        let value = startTime.add(15, "minutes").format("hh:mm A");
        if (startTime && startTime.isSameOrBefore(minTime)) {
          this.timeList.push({ text: value, value, disabled: true });
        } else {
          this.timeList.push({ text: value, value, disabled: false });
        }
      }
      const current = this.timeList.find((item) => item.value === this.time);
      if (current && current.disabled) {
        const corrected = this.timeList.find(
          (item) =>
            !item.disabled &&
            (!minTime ||
              moment(`${this.minDate} ${item.value}`, "YYYY-MM-DD hh:mm A").isSameOrAfter(
                minTime.clone().add(60, "minutes")
              ))
        );
        if (corrected) {
          this.time = corrected.value;
          this.emitValue();
        } else {
          this.time = null;
          this.emitValue();
        }
      }
    },
  },
  created() {
    this.initTimeList();
  },
  mounted() {
    this.init();
  },
};
</script>
